"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _html2nodelist = _interopRequireDefault(require("./_html2nodelist"));

var win = window; // function-constructor of mq library
// accepts many kinds of arguments (selector, html, function)

function MQInit(selector, context) {
  var result;

  if (selector) {
    if (selector.nodeType || (0, _typeof2["default"])(win) === 'object' && selector === win) {
      result = [selector];
    } else if (typeof selector === 'string') {
      if (/</.test(selector)) {
        result = (0, _html2nodelist["default"])(selector);
      } else if (context) {
        var newContext = new MQInit(context)[0];

        if (newContext) {
          result = newContext.querySelectorAll(selector);
        }
      } else {
        result = win.document.querySelectorAll(selector);
      }
    } else if ('length' in selector) {
      // if it's something array-like (eg NodeList)
      result = selector;
    } else {
      // this is somethong another (eg Attr)
      result = [selector];
    }
  }

  var length = result && result.length;

  if (length) {
    for (var i = 0; i < length; i++) {
      this.push(result[i]);
    }
  }

  return this;
}

MQInit.prototype = [];
var _default = MQInit;
exports["default"] = _default;
//# sourceMappingURL=_init.js.map